import React, {useEffect} from 'react';
import {ConfirmDialog} from "../../fusion-ui";
import {checkNullStr, isBoolTrue} from "../../fusion-ui/utils/ReactUtils";

/**
 * Create a theme based confirm-dialog.
 *
 * @example
 *      const [showDialog, setShowDialog] = useState(false);
 *
 *      <ThemedConfirmDialog
 *          open={showDialog}
 *          onCancel={() => setShowDialog(false)}
 *          onHide={() => setShowDialog(false)}
 *          title={`Confirm Dialog`}
 *          subMsg={'This is sub-message!'}
 *          operation={'delete'}
 *          target={'this record'}
 *          onConfirm={() => {
 *              setShowDialog(false);
 *          }}
 *         />
 *
 *      />
 */
const ThemedConfirmDialog = React.memo(({
                                            title = 'Confirm',
                                            widthClass = 'col-sm-10 col-md-6',
                                            // md = '',
                                            subMsg,
                                            open,
                                            onClose,
                                            onCancel,
                                            onHide,
                                            onConfirm,
                                            operation,
                                            textAt = 'center',
                                            target,
                                            showIrreversibleMsg = false,
                                        }) => {
    const TAG = "ThemedConfirmDialog";

    useEffect(() => {

    }, []);

    return (<ConfirmDialog
            widthClass={widthClass}
            open={open}
            onClose={onClose}
            className={''}
            closeOnEscape={true}
            closeOnOutsideClick={false}
            enableEnter={false}
            onConfirm={onConfirm}
            onCancel={onCancel}
            onHide={onHide}
            title={title}
            contentFontSize={""}
            confirmText={'Delete'}
            contentClassName={"text-dark px-3 py-1"}
            confirmClassName={'bg-danger'}
            cancelClassName={'highlight-dark highlight-dark-high-hover'}
        >
            <p className={`p-0 m-0 mt-1 mb-1 fs-normal text-${textAt}`}>Are you sure you want to {operation} <span className={'fw-bold'}>{target}</span>?</p>
            {checkNullStr(subMsg) && <p className={`p-0 m-0 my-1 text-${textAt}`}>({subMsg})</p>}

            {isBoolTrue(showIrreversibleMsg) &&
                <p className={'p-0 m-0 w-100 fs-sm-md text-gray mt-2 text-center text-wrap'}>(The above action is irreversible)</p>
            }
        </ConfirmDialog>
    )

    function fun() {

    }
});
export default ThemedConfirmDialog;
